export const BLOCK_NAME = 'b-btn-fixed'
export const CLASS_NAMES = {
  buttonActive: `${BLOCK_NAME}_active`,
}
